import { render, staticRenderFns } from "./ModelVersionsDesktop.vue?vue&type=template&id=51164019"
import script from "./ModelVersionsDesktop.vue?vue&type=script&lang=js"
export * from "./ModelVersionsDesktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports